import { FOLDER_TRASH_ID } from "@zapier/utils";
import { trpc } from "../trpc";

/** Mutation hook that permanently deletes mixed asset ids from trash and invalidates trash/canvas/zap-inventory caches. */
export function useBulkDeleteAssets() {
  const utils = trpc.useUtils();

  return trpc.asset.bulkDelete.useMutation({
    onSettled: () => {
      utils.canvas.search.invalidate();
      utils.zap.searchZaps.invalidate();
      utils.zap.storageZaps.invalidate();
      utils.zap.organizationZaps.invalidate();

      utils.asset.getHydratedFolderAssets.invalidate();

      utils.asset.getHydratedFolderAssets.invalidate({
        folderId: FOLDER_TRASH_ID,
      });
    },
  });
}
